import { useEffect, useState } from "react";

const useVisibility = () => {
    const [visibilityStatus, setVisibilityStatus] = useState("hidden");

    const handleSleepModeStatus = () => {
        setVisibilityStatus(document.visibilityState);
    }

    useEffect(() => {
        window.addEventListener("visibilitychange", handleSleepModeStatus);

        return () => {
            window.removeEventListener("visibilitychange", handleSleepModeStatus);
        };
    }, []);
    return visibilityStatus;
};

export default useVisibility;